import React, {createContext, useReducer} from "react";
import {WorkstationMetricsViewReducer} from "../reducers/WorkstationMetricsViewReducer";
import {WORKSTATION_METRIC_SPANS} from "../../pickStatus/constants/Constants";

export const WorkstationMetricsContext = createContext();

const WorkstationMetricsContextProvider = (props) => {
    const initialMetricsViewData = {
        granularity : WORKSTATION_METRIC_SPANS.cumulative,
        metricsTableData : {}
    };
    const [metricsViewData, dispatchMetricsView] = useReducer(WorkstationMetricsViewReducer, initialMetricsViewData);

    return (
        <WorkstationMetricsContext.Provider value = {{metricsViewData, dispatchMetricsView}}>
            {props.children}
        </WorkstationMetricsContext.Provider>
    )
}

export default WorkstationMetricsContextProvider


// WEBPACK FOOTER //
// ./src/components/workstationMetrics/context/WorkstationMetricsContext.js